const selector = "#ProductGridContainer";
let cacheManager = {};

window.addEventListener('pageshow', function(e){
  console.log(`Persisted: ${e.persisted}`);
  onLoad(e);
});

function onLoad(e){
  cacheManager = new PageCacheManager(
    { 
      bodySelector: selector,
      onLoaded: onLoadedCache,
      onCached: onCachedCache,
    }
  );
  
  if(!e.persisted)
  {
    document.addEventListener('click',function(e){
      const closest = e.target.closest('#product-grid .card-wrapper a');
      console.log(closest);
      if(closest) cacheManager.cachePage();
    });
  }
}

function infiniteScrollCollection() {
  var endlessScroll = new Ajaxinate({
    container: '#ProductGridContainer .grid--view-items',
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    loadingText: '',
    offset: 1000,
    callback: callBack
    });
}

function callBack() {
    const items = document.querySelectorAll('#product-grid > .grid__item').length;
    document.querySelector('#ProductCountPagination').innerHTML = items;

    if (document.querySelector('#scrollToTopBtn')) {
      document.querySelector('#scrollToTopBtn').classList.remove('hidden');
    }
}

function onLoadedCache(e){
  console.log('loaded');
  infiniteScrollCollection();
  document.querySelector(selector).style.visibility = 'visible';
};

function onCachedCache(e){
  console.log('cached');
  document.querySelector(selector).style.visibility = 'hidden';
};